export default function Removeduplicates(originalArray, prop) {
  let newArray = [];
  let lookupObject = {};
  for (let i in originalArray) {
    lookupObject[originalArray[i][prop]] = originalArray[i];
  }
  for (let i in lookupObject) {
    newArray.push(lookupObject[i]);
  }
  return newArray;
}

export const validateURL = (url) => {
  if (!url || typeof url !== "string") return false;
  
  const trimmedUrl = url.trim();
  
  // Remove protocol and www to analyze the core domain
  let cleanUrl = trimmedUrl.replace(/^https?:\/\//, '').replace(/^www\./, '');
  
  // Remove path, query, and fragment for domain analysis
  cleanUrl = cleanUrl.split('/')[0].split('?')[0].split('#')[0];
  
  // Split domain into parts
  const domainParts = cleanUrl.split('.');
  
  // Must have at least 2 parts (domain.tld)
  if (domainParts.length < 2) return false;
  
  // Extract TLD (last part) and domain name (second to last part)
  const tld = domainParts[domainParts.length - 1].toLowerCase();
  const domainName = domainParts[domainParts.length - 2];
  
  // Domain name cannot be "www" or empty
  if (!domainName || domainName.toLowerCase() === 'www' || domainName.length < 1) {
    return false;
  }
  
  // Validate domain name format (letters, numbers, hyphens, but not starting/ending with hyphen)
  const domainRegex = /^[a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?$/;
  if (!domainRegex.test(domainName)) return false;
  
  // Validate TLD format (letters only, 2+ characters)
  const tldRegex = /^[a-zA-Z]{2,}$/;
  if (!tldRegex.test(tld)) return false;
  
  // Known TLD validation
  const knownTLDs = [
    'com', 'org', 'net', 'edu', 'gov', 'mil', 'int', 'co', 'io', 'ai', 'app',
    'dev', 'tech', 'info', 'biz', 'name', 'pro', 'travel', 'museum', 'aero',
    'asia', 'cat', 'coop', 'jobs', 'mobi', 'tel', 'post', 'geo',
    // Country codes
    'us', 'uk', 'ca', 'au', 'de', 'fr', 'jp', 'cn', 'in', 'br', 'ru', 'it',
    'es', 'nl', 'se', 'no', 'dk', 'fi', 'be', 'ch', 'at', 'pl', 'cz', 'hu',
    'pt', 'gr', 'tr', 'il', 'za', 'eg', 'ng', 'ke', 'ma', 'tz', 'gh', 'ug',
    'mx', 'ar', 'cl', 'co', 've', 'pe', 'ec', 'uy', 'py', 'bo', 'cr', 'gt',
    'hn', 'ni', 'pa', 'sv', 'do', 'cu', 'jm', 'ht', 'tt', 'bb', 'gd', 'ag',
    'lc', 'vc', 'dm', 'kn', 'ms', 'vg', 'ai', 'tc', 'ky', 'bz', 'gp', 'mq',
    'sr', 'gf', 'fk', 'gs', 'sh', 'ac', 'ta', 'io', 'bv', 'sj', 'um', 'aq'
  ];
  
  return knownTLDs.includes(tld);
};





